






























































































import { ImportMetadataApi } from "../api/ImportMetadataApi";
import Pagination from "../core/UI/Pagination.vue";
import PerPage from "../core/UI/PerPage.vue";
import AutoRefresh from "../core/Table/AutoRefresh.vue";
import { SettingApi } from "../api/SettingApi";
import { Setting } from "../models/Setting";
import ProcessedDocumentDetailModal from "./ProcessedDocumentDetailModal.vue";

export default {
    name: "ProcessedDocumentsList",
    components: {
        ProcessedDocumentDetailModal,
        Pagination,
        PerPage,
        AutoRefresh,
    },
    props: {},
    data() {
        return {
            importMetadata: [],
            ImportMetadataApi: new ImportMetadataApi(),
            SettingApi: new SettingApi(),
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            loading: false,
            token_cost: 0,
            importMetadataModal: {
                show: false,
                selected: null,
            },
        };
    },
    created() {
        this.loadPage(this.currentPage);
        this.SettingApi.get(Setting.settingsKeys.token_cost).then(
            (response) => {
                this.token_cost = response.value;
            }
        );
    },
    methods: {
        loadPage(page, hideLoading = false) {
            let self = this;
            let params = {
                limit: self.itemsPerPage,
                page: page,
                include: "files",
            };

            self.loading = !hideLoading;

            return self.ImportMetadataApi.getAll(params)
                .then(function (response) {
                    let { data, paginator } = response;
                    self.importMetadata = data;
                    self.totalPages = paginator.total_pages;
                    self.currentPage = paginator.current_page;

                    return self.importMetadata;
                })
                .catch(function (error) {
                    self.importMetadata = [];
                    console.error("Error loading import metadata:", error);
                })
                .finally(function () {
                    self.loading = false;
                });
        },
        refreshData() {
            if (!this.loading) {
                this.loadPage(this.currentPage, true);
            }
        },
        // UI
        getCost(tokens) {
            return _.round((tokens * this.token_cost) / 1000000, 2);
        },
        showDetailModal(importMetadata) {
            this.importMetadataModal.show = true;
            this.importMetadataModal.selected = importMetadata;
        },
        closeDetailModal() {
            this.importMetadataModal.show = false;
        },
    },
    watch: {
        itemsPerPage: function () {
            this.loadPage(1);
        },
    },
};
